import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import DataTable from "../../_Components/DataTable";
import _ from "lodash";
import Avatar from "@mui/material/Avatar";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";

let showPrice = Intl.NumberFormat("en-US");
const useStyles = styled({
  pinkAvatar: {
    marginTop: 10,
    marginRight: 2,
    marginBottom: 10,
    color: "#fff",
    width: "22px",
    height: "22px",
    alignItems: "end",
  },
});

const changData = (rowData, statusType = "canceled") => {
  // تعریف وضعیت‌های مختلف
  const statusConfigs = {
    canceled: {
      statuses: [
        { id: 1, label: "درخواست_کنسلی", bgColor: "#3699ff" },
        { id: 2, label: "پیگیری کنسلی", bgColor: "rgb(182 206 232)" },
        { id: 3, label: "رهاسازی کنسلی", bgColor: "#3699ff" },
        { id: 4, label: "کنسل شد", bgColor: "#40900378" },
        { id: 5, label: "رد درخواست کنسلی", bgColor: "#d55e0185" },
      ],
      statusField: "cancelStatus",
      filterCondition: (person) => person.cancelStatus !== 0,
    },
    supplierCancel: {
      statuses: [
        { id: 1, label: "درخواست_کنسلی", bgColor: "#3699ff" },
        { id: 2, label: "پیگیری کنسلی", bgColor: "rgb(182 206 232)" },
        { id: 3, label: "رهاسازی کنسلی", bgColor: "#3699ff" },
        { id: 4, label: "کنسل شد", bgColor: "#40900378" },
        { id: 5, label: "رد درخواست کنسلی", bgColor: "#d55e0185" },
      ],
      statusField: "supplierCancelStatus",
      filterCondition: (person) => person.supplierCancelStatus !== 0,
    },
    normal: {
      statuses: [
        { label: "جدید", bgColor: "#3699ff" },
        { label: "در_حال_پیگیری", bgColor: "rgb(182 206 232)" },
        { label: "رهاسازی", bgColor: "#3699ff" },
        { label: "انجام_شده", bgColor: "#40900378" },
        { label: "انجام_نشده", bgColor: "#d55e0185" },
      ],
      statusField: "currentStatusS",
      filterCondition: (person) => person.cancelStatus !== 4,
    },
  };
  // انتخاب پیکربندی مناسب بر اساس نوع وضعیت
  const config =
    statusType === "canceled"
      ? statusConfigs.canceled
      : statusType === "supplierCancel"
        ? statusConfigs.supplierCancel
        : statusConfigs.normal;
  // محاسبه تعداد هر وضعیت
  const statusesWithCount = config.statuses.map((status) => {
    let count = 0;
    rowData.basketItems?.forEach((basketItem) => {
      count +=
        basketItem.basketItemPersons?.filter((person) => {
          if (config.statusField === "currentStatusS") {
            return person.currentStatusS === status.label && config.filterCondition(person);
          } else {
            return person[config.statusField] === status.id && config.filterCondition(person);
          }
        }).length || 0;
    });
    return { ...status, count };
  });
  // رندر آواتارها
  return (
    <Grid container justifyContent="center" alignItems="center">
      {statusesWithCount.map(
        (item) =>
          item.count > 0 && (
            <Avatar
              key={`${statusType}-${item.id || item.label}`}
              sx={{ width: 24, height: 24 }}
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title={item.label}
              // className={classes.pinkAvatar}
              style={{ backgroundColor: item.bgColor }}
            >
              {item.count}
            </Avatar>
          ),
      )}
    </Grid>
  );
};

function DataGridOrders({ data }) {
  // const classes = useStyles();

  const columns = useMemo(() => [
    {
      accessor: "id",
      Header: "#",
      minWidth: 50,
    },
    {
      accessor: "createdFullName",
      Header: "نام ونام خانوادگی",
      minWidth: "100px",
    },
    {
      accessor: "phoneNumber",
      Header: "شماره تماس",
      minWidth: "100px",
    },
    {
      accessor: "originalPrice",
      Header: "قیمت اصلی",
      minWidth: "100px",
      Cell: ({ row }) => showPrice.format(row.original.originalPrice),
    },
    {
      accessor: "price",
      Header: "قیمت",
      minWidth: "100px",
      Cell: ({ row }) => showPrice.format(row.original.price),
    },

    {
      accessor: "canceledStatus",
      Header: "وضعیت کنسلی",
      minWidth: 100,
      Cell: ({ row }) => <div>{changData(row.original, "canceled")}</div>,
    },
    {
      accessor: "supplierCancelStatus",
      Header: "وضعیت کنسلی تامین کننده",
      minWidth: 100,
      Cell: ({ row }) => <div>{changData(row.original, "supplierCancel")}</div>,
    },
    {
      accessor: "createdPersianTime",
      Header: "زمان ایجاد",
      minWidth: 90,
      maxWidth: 90,
    },
    {
      Header: "عملیات",
      accessor: "",
      minWidth: 150,
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          {/* ویرایش */}
          <Link className="btn btn-light-primary" to={`/ViewCanceledOrderContents/${row.original.id}`} title="ویرایش">
            <i className="far fa-edit text-small"></i>
          </Link>
        </div>
      ),
    },
  ]);

  const config = useMemo(() => ({
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  }), []);
  return (
    <div>
      {/* {changData(data)} */}
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGridOrders;
